module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Cheese-369caf1999af49b4323a282a3bd1513c3b157169c0faebdf948d2f599537eb9b.svg";